import { Box, Card, Typography } from '@mui/material'
import { STARTSurveyDisplay } from '../../../../customComponents/survey/STARTSurveyDisplay'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { SurveyType } from '../../../../../models/SurveySchema'
import { useAnnualPlanUserRole } from '../../../../../hooks/use-annualPlanUserRole'
import { AppRoutes } from '../../../../Routes'
import { ImplementationDetailsTabs } from '../../ImplementationDetails'
import { styles } from './MidYear.styles'
import { AnnualPlanRole } from '../../../../../models/AnnualPlanRole'

export function MidYear (): JSX.Element {
  const { rcnId, planId, orgId } = useParams()
  const annualPlanId = planId != null ? Number(planId) : 0
  const { userRole, isLoading } = useAnnualPlanUserRole(annualPlanId)
  const nav = useNavigate()

  if (isLoading || userRole == null) {
    return <div>Loading...</div>
  }

  const isISD = userRole === AnnualPlanRole.PlanContributor
  const schemaId = isISD ? SurveyType.ISDMidYear : SurveyType.RCNMidYear

  const navigateToSummary = (): void => {
    if (rcnId == null || planId == null || orgId == null) return

    const path = generatePath(
      AppRoutes.IMPLEMENTATION_PROGRESS_REPORTS_ORGANIZATION_MIDYEAR_SUMMARY,
      {
        rcnId,
        planId,
        tab: String(ImplementationDetailsTabs.ProgressReports),
        orgId
      }
    )
    nav(path)
  }

  return (
    <Card sx={styles.card} data-testid='midYearReportCard'>

      <Box sx={styles.content}>
        <Box sx={styles.header}>
          <Typography variant='h1'>Progress Reports</Typography>
        </Box>

        <Typography variant='body1'>
          Share information about your progress toward your Implementation Plan with START at Mid-Year and End of Year by completing the Progress Reports.
        </Typography>

        <Box sx={styles.surveyContainer}>
          <STARTSurveyDisplay
            annualPlanId={annualPlanId}
            surveyType={schemaId}
            navigationButtonStyles={styles.navButtons}
            title={isISD ? 'ISD Progress on Contract Goals' : 'RCN Mid-Year'}
            navigateToSummary={navigateToSummary}
          />
        </Box>
      </Box>
    </Card>
  )
}
